import MDAlert from "components/MDAlert";
import MDTypography from "components/MDTypography";
import { CustomGetProposalDocument, Proposal, ProposalStage } from "generated/graphql";
import useCustomAddProductsToProposalStage from "hooks/proposals/useCustomAddProductsToProposalStage";
import SelectProductForm, { ProductMeasurement } from "modules/products/forms/SelectProductForm";
import { useCallback } from "react";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";

export default function SelectStageProduct({
  stage,
  onSuccess,
}: {
  stage: ProposalStage;
  onSuccess: (product: Proposal) => void;
}) {
  const [addProductsToProposalStage, { loading, error, isSuccess, getData }] =
    useCustomAddProductsToProposalStage();

  const handleOnSubmit = useCallback(
    async (measurements: ProductMeasurement[]) => {
      const result = await addProductsToProposalStage({
        variables: {
          input: {
            proposalStageId: stage.id,
            products: measurements.map((measurement) => ({
              id: measurement.id,
              jobSize: parseInt(measurement.jobSize.toString()) || 0,
              dailyUnitsComplete: measurement.dailyUnitsComplete || null,
              jobDuration: parseInt(measurement.jobDuration) || null,
              ...(measurement.mapData && { mapData: measurement.mapData }),
            })),
          },
        },
      });

      const success = isSuccess(result.data);
      const data = getData(result);

      if (success) {
        onSuccess(data as Proposal);
      }

      return { success, data };
    },
    [stage.id, addProductsToProposalStage]
  );

  return (
    <div>
      {error && <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>}
      <SelectProductForm onSubmit={handleOnSubmit} loading={loading} mapData={stage.mapData} />
    </div>
  );
}
